/** @jsx builderX.jsx */

import {builderX, Sprite, Image} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name="waterMark_portrait">
        <Sprite name="balanceContainer">
            <Image position={[-390, -72]} name="bgBottom" src="net_balance_black_mob_p"/>
            <Sprite position={[0, -72]} name="labelBalanceContainer"/>
        </Sprite>
        <Sprite name="clockContainer">
            <Image position={[-380, 0]} name="bgTop" src="timer_black_back"/>
            <Image position={[-300, 20]} name="ui_timer_icon" src="ui_timer_icon"/>
            <Sprite position={[-135, 17]} name="labelClockContainer"/>
        </Sprite>
        <Sprite name="globalClockContainer">
            <Image position={[-380, 0]} name="bgTop" src="timer_black_back"/>
            <Sprite position={[-135, 17]} name="labelClockContainer"/>
        </Sprite>
        <Sprite name="gameNameContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite name="sessionEarningsContainer">
            <Image position={[-100, -72]} name="bgBottom" src="net_balance_black_mob_p"/>
            <Sprite position={[0, -72]} name="labelContainer"/>
        </Sprite>
        <Sprite name="sessionBetsContainer">
            <Image position={[-680, -72]} name="bgBottom" src="net_balance_black_mob_p"/>
            <Sprite position={[0, -72]} name="labelContainer"/>
        </Sprite>
        <Sprite position={[0, -60]} name="maxWinProbabilityContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite position={[0, 100]} name="RTPContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
    </Sprite>
);
